import _ from 'underscore';
import { getAuthrtMenuList } from '../apis/loginApi';

export const makeMenuTree = menuList => {
  // 1. level 0인 최상위 메뉴들을 먼저 찾음
  const rootMenus = menuList.filter(menu => menu.level === 0);

  // 2. 재귀적으로 자식 메뉴를 찾아 추가하는 함수
  const buildTree = parentMenu => {
    const children = menuList.filter(
      menu => menu.upperMenuId === parentMenu.menuId
    );

    if (children.length) {
      // 자식이 있으면 각 자식에 대해 재귀적으로 트리 구성
      parentMenu.children = children.map(child => {
        return buildTree(child);
      });
    }

    return parentMenu;
  };

  // 3. 각 최상위 메뉴에 대해 트리 구성
  const menuTree = rootMenus.map(root => buildTree(root));

  return menuTree;
};

// 권한 아이디에 따른 메뉴 로딩
export const getAuthrtMenu = async authrtId => {
  let response;

  try {
    response = await getAuthrtMenuList(authrtId);

    if (response instanceof Error) {
      alert('There is a no menu fit');
    } else {
      const menuTree = makeMenuTree(response);
      return menuTree;
    }
  } catch (error) {
  }
};

const isValidOffNum = input => {
  let tmpStr = input;

  let tmpSum = 0;
  let tmpMod = 0;
  let resValue = 0;

  let intOffNo = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  let strChkNum = [1, 3, 7, 1, 3, 7, 1, 3, 5];

  for (let i = 0; i < 10; i++) {
    intOffNo[i] = parseInt(tmpStr.substring(i, i + 1));
  }

  for (var i = 0; i < 9; i++) {
    tmpSum = tmpSum + intOffNo[i] * strChkNum[i];
  }

  tmpSum = tmpSum + (intOffNo[8] * 5) / 10;
  tmpMod = parseInt((tmpSum % 10).toString(), 10);

  if (tmpMod == 0) {
    resValue = 0;
  } else {
    resValue = 10 - tmpMod;
  }

  if (resValue == intOffNo[9]) {
    return true;
  } else {
    return false;
  }
};

// 사업자등록번호 체크로직
export const isValidBrNo = brNo => {
  if (brNo == null || brNo == undefined) {
    return false;
  }

  if (brNo.length == 0) {
    return false;
  }

  if (_.isNumber(brNo)) {
    brNo = brNo.toString();
  }

  if (brNo.length != 10) {
    return false;
  }

  let err = isValidOffNum(brNo);

  if (!err) {
    return false;
  }

  return true;
};

export const isValidPassword = password => {
  const lengthValid = password.length >= 8 && password.length <= 20;
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password); // 대문자 검증 추가
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  // 키보드 배열 (대소문자 포함)
  const keyboardRows = [
    '1234567890',
    'qwertyuiop',
    'asdfghjkl',
    'zxcvbnm',
    'QWERTYUIOP',
    'ASDFGHJKL',
    'ZXCVBNM',
  ];

  // 연속된 키보드 문자 검증 (대소문자 고려)
  const isSequentialKeyboard = str => {
    for (let i = 0; i < str.length - 2; i++) {
      const substr = str.slice(i, i + 3);
      for (const row of keyboardRows) {
        if (row.includes(substr)) {
          return true;
        }
      }
    }
    return false;
  };

  // 연속된 숫자 검증
  const isSequentialNumber = str => {
    for (let i = 0; i < str.length - 2; i++) {
      const num1 = parseInt(str[i]);
      const num2 = parseInt(str[i + 1]);
      const num3 = parseInt(str[i + 2]);
      if (
        !isNaN(num1) &&
        !isNaN(num2) &&
        !isNaN(num3) &&
        ((num2 === num1 + 1 && num3 === num2 + 1) || // 증가
          (num2 === num1 - 1 && num3 === num2 - 1)) // 감소
      ) {
        return true;
      }
    }
    return false;
  };

  // 연속된 영문자 검증
  const isSequentialLetters = str => {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz';
    const reversedAlphabet = alphabet.split('').reverse().join('');
    const lowerPassword = str.toLowerCase();
    for (let i = 0; i < lowerPassword.length - 2; i++) {
      const substr = lowerPassword.slice(i, i + 3);
      if (alphabet.includes(substr) || reversedAlphabet.includes(substr)) {
        return true;
      }
    }
    return false;
  };

  // 동일 문자 반복 검증
  const isRepeatedChar = str => /(.)\1{2}/.test(str); // 3번 이상 반복

  // 동일 숫자 반복 검증
  const isRepeatedNumber = str => /(\d)\1{2}/.test(str); // 3번 이상 반복

  const sequentialKeyboardValid = !isSequentialKeyboard(password);
  const sequentialNumberValid = !isSequentialNumber(password);
  const sequentialLettersValid = !isSequentialLetters(password);
  const repeatedCharValid = !isRepeatedChar(password);
  const repeatedNumberValid = !isRepeatedNumber(password);

  // 상태 코드 정의
  let status = '';
  if (!lengthValid) {
    status = 'LENGTH_INVALID';
  } else if (!hasLetter) {
    status = 'NO_LETTER';
  } else if (!hasUpperCase) {
    status = 'NO_UPPERCASE'; // 대문자 검증 추가
  } else if (!hasNumber) {
    status = 'NO_NUMBER';
  } else if (!hasSpecialChar) {
    status = 'NO_SPECIAL_CHAR';
  } else if (!sequentialKeyboardValid) {
    status = 'SEQUENTIAL_KEYBOARD';
  } else if (!sequentialNumberValid) {
    status = 'SEQUENTIAL_NUMBER';
  } else if (!sequentialLettersValid) {
    status = 'SEQUENTIAL_LETTERS';
  } else if (!repeatedCharValid) {
    status = 'REPEATED_CHAR';
  } else if (!repeatedNumberValid) {
    status = 'REPEATED_NUMBER';
  }

  // 메시지를 switch-case로 처리
  switch (status) {
    case 'LENGTH_INVALID':
      return '비밀번호는 최소 8자 이상 20자 이하여야 합니다.';
    case 'NO_LETTER':
      return '비밀번호에 최소 한 개의 영문자를 포함해야 합니다.';
    case 'NO_UPPERCASE':
      return '비밀번호에 최소 한 개의 대문자를 포함해야 합니다.'; // 대문자 메시지 추가
    case 'NO_NUMBER':
      return '비밀번호에 최소 한 개의 숫자를 포함해야 합니다.';
    case 'NO_SPECIAL_CHAR':
      return '비밀번호에 최소 한 개의 특수문자를 포함해야 합니다.';
    case 'SEQUENTIAL_KEYBOARD':
      return '비밀번호에 연속된 키보드 문자열을 포함할 수 없습니다.';
    case 'SEQUENTIAL_NUMBER':
      return '비밀번호에 연속된 숫자를 포함할 수 없습니다.';
    case 'SEQUENTIAL_LETTERS':
      return '비밀번호에 연속된 영문자를 포함할 수 없습니다.';
    case 'REPEATED_CHAR':
      return '비밀번호에 동일한 문자를 3번 이상 반복할 수 없습니다.';
    case 'REPEATED_NUMBER':
      return '비밀번호에 동일한 숫자를 3번 이상 반복할 수 없습니다.';
    default:
      return ''; // 유효한 비밀번호
  }
};
// 이메일 형식 체크로직
export const isValidEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// 날짜를 00:00:00 또는 23:59:59로 설정하는 유틸리티 함수 (기간 조회 시 사용용)
export const formatDateToISOString = (date, isEndOfDay = false) => {
  if (!date) return null;

  const adjustedDate = new Date(date);
  if (isEndOfDay) {
    adjustedDate.setHours(23, 59, 59, 999);
  } else {
    adjustedDate.setHours(0, 0, 0, 0);
  }

  const year = adjustedDate.getFullYear();
  const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
  const day = String(adjustedDate.getDate()).padStart(2, '0');
  const hours = String(adjustedDate.getHours()).padStart(2, '0');
  const minutes = String(adjustedDate.getMinutes()).padStart(2, '0');
  const seconds = String(adjustedDate.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};
